/* eslint-disable react-refresh/only-export-components */
/* eslint-disable filename-rules/match */
import { t } from "i18n/i18n";
import { GearSettingsIcon, PersonSingleIcon, PersonSingleStarIcon, StarIcon } from "mds/icons";
import { HomeRole } from "utils/urls";

export const PARTICIPANT_ROLES = [
  HomeRole.STUDENT,
  HomeRole.INSTRUCTOR,
  HomeRole.SECTION_ASSISTANT,
] as const;
export const ASSESSING_ROLES = [HomeRole.INSTRUCTOR, HomeRole.SECTION_ASSISTANT] as const;

// Use Permissions for these things
export const isStaff = (role: HomeRole) => role !== HomeRole.STUDENT;
export const isAssessor = (role: HomeRole) =>
  ASSESSING_ROLES.includes(role as (typeof ASSESSING_ROLES)[number]);
export const isParticipant = (role: HomeRole) =>
  PARTICIPANT_ROLES.includes(role as (typeof PARTICIPANT_ROLES)[number]);

export const roleLabel: Record<HomeRole, string> = {
  student: t("home.role.student"),
  instructor: t("home.role.instructor"),
  admin: t("home.role.admin"),
  section_assistant: t("home.role.section_assistant"),
};

export const roleIcon: Record<HomeRole, React.ReactNode> = {
  student: <PersonSingleIcon />,
  instructor: <StarIcon />,
  section_assistant: <PersonSingleStarIcon />,
  admin: <GearSettingsIcon />,
};
